import * as babylon from "@babylonjs/core";

// Creates a grid along Babylon's horizontal axis (XZ)
export function createGridMesh(
  name: string,
  gridSize: number,
  totalLength: number,
  scene: babylon.Scene,
): babylon.Mesh {
  const lines: babylon.Vector3[][] = [];
  // Build a grid that goes from 0,0 to end,end in all 4 quadrants.
  const end = totalLength / 2;
  for (let i = 0; i <= end; i += gridSize) {
    // X axis gridlines
    lines.push([v3(i, 0, -end), v3(i, 0, end)]);
    lines.push([v3(-i, 0, -end), v3(-i, 0, end)]);

    // Z axis gridlines
    lines.push([v3(-end, 0, i), v3(end, 0, i)]);
    lines.push([v3(-end, 0, -i), v3(end, 0, -i)]);
  }

  // Combine all the lines into a single mesh
  const gridMesh = babylon.MeshBuilder.CreateLineSystem(
    name,
    {
      lines,
    },
    scene,
  );
  gridMesh.name = name;
  gridMesh.alwaysSelectAsActiveMesh = true;
  return gridMesh;
}

function v3(x: number, y: number, z: number) {
  return new babylon.Vector3(x, y, z);
}
